<template>
    <el-drawer title="点赞" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close">
        <div class="drawer-content">
            <el-form :model="formDatas" :rules="rules" ref="formDatas" label-position="top" size="medium">
                <el-form-item prop="user" label="点赞人:">
                    <el-select v-model="formDatas.user" filterable remote placeholder="请输入点赞人"
                        :remote-method="searchUser" :loading="userLoading" size="medium" value-key="id">
                        <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>
<script>
import {fetchUser} from "@/assets/js/commonApi.js";

export default {
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            formData: {},
            formDatas: {
                user: null
            },
            rules: {
                user: [{ required: true, message: "请选择点赞人" }]
            },
            userList: [],
            userLoading: false,

            type: 1, //1:帖子点赞，2:评论点赞
        }
    },
    methods: {
        close() {
            this.$refs.formDatas.resetFields();
            this.drawerShow = false;
            this.formDatas = {
                user: ""
            }
        },
        show(id, type) {
            if( type == 1 ){
                this.formData.articleId = id;
            }else{
                this.formData.reviewId = id;
            }
            this.type = type;
            this.drawerShow = true;
        },
        // 搜索用户
        async searchUser(query){
            if(query !== ""){
                this.userLoading = true;
                const res = await fetchUser({
                    queryValue:query,
                    userType: 0
                }).finally(() => {
                    this.userLoading = false;
                });
                
                const { state, result } = res.data;
                
                if (state == 1 && result) {
                    this.userList= result;
                }
            }
        },

        // 提交点赞
        /**
         * 帖子点赞参数 {articleId,userId,userName}
         * 评论点赞参数 {reviewId,userId}
         */
        submitForm() {
            this.$refs["formDatas"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: this.type == 1 ? '/article/ding' : '/article/review/ding',
                        params: {
                            ...this.formData,
                            userId: this.formDatas.user.id,
                            userName: this.formDatas.user.name
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.close();
                                setTimeout( () => {
                                    this.$emit('onUpdate');
                                },1500)
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
</style>